import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Colors, Text } from 'library';
import { Availability } from './CalendarAvailability';
import moment from 'moment';

interface TwoWeekItem {
    day_of_month: number;
    is_today: boolean;
    is_available: boolean;
}

export default function TwoWeekAvailabilityGrid({ availability }: { availability: Availability[] }) {
    const [twoWeeks, setTwoWeeks] = useState<TwoWeekItem[]>([]);

    useEffect(() => {
        let data: TwoWeekItem[] = [];
        if (availability && availability?.length) {
            let date = getSundayOfCurrentWeek();
            const today = new Date();
            for (let i = 0; i < 14; i++) {
                let newItem: TwoWeekItem = {
                    day_of_month: date.getDate(),
                    is_today: date.getDate() === today.getDate(),
                    is_available: isAvailableOnDate(date),
                };
                data.push(newItem);
                date.setDate(date.getDate() + 1);
            }
        }
        setTwoWeeks(data);
    }, [availability]);

    const getSundayOfCurrentWeek = () => {
        const today = new Date();
        const first = today.getDate() - today.getDay() + 1;
        return new Date(today.setDate(first));
    };

    const isAvailableOnDate = (curDate: Date) => {
        const curDateStr = moment(curDate).format('YYYY-MM-DD');
        const day = availability.find((item) => moment(item.date).format('YYYY-MM-DD') === curDateStr);
        if (day) {
            return day.t_06_09 || day.t_09_12 || day.t_12_15 || day.t_15_18 || day.t_18_21 || day.t_21_24;
        }
        return false;
    };

    return (
        <Grid container direction="row" style={{ marginTop: 20, width: 310, backgroundColor: '#FDFDFD' }}>
            {twoWeeks.map((item) => (
                <Grid
                    item
                    container
                    style={{
                        width: 40,
                        height: 36,
                        backgroundColor: item.is_available ? Colors.turquoise : '#EFEFEF',
                        marginRight: 3,
                        marginBottom: 3,
                        border: item.is_today ? '1px solid black' : 'none',
                    }}
                    justify="center"
                    alignItems="center"
                >
                    <Text
                        variant="body2"
                        color={item.is_available ? Colors.white : Colors.darkNavy}
                        textStyle={!item.is_available ? { textDecoration: 'line-through' } : {}}
                    >
                        {item.day_of_month}
                    </Text>
                </Grid>
            ))}
        </Grid>
    );
}
